import { Workspace } from '@/features/user-settings/types/workspace-types';

import {
	ISUserDetails,
	IUserDetailsPage,
	IUserDetailsResponse,
} from '@/shared/services/user/user.types';

import { JsonValue, transformKeysSnakeToCamelCase } from '@/utils/transformation';

export function getStructuredUserDetailsPage(obj: IUserDetailsPage) {
	const structuredObj = transformKeysSnakeToCamelCase(
		obj as unknown as JsonValue
	) as unknown as Omit<Workspace, 'pageUsers' | 'isPro'>;

	return structuredObj;
}

export function getStructuredUserDetailsResponse(obj: IUserDetailsResponse) {
	const structuredObj: ISUserDetails = {
		email: obj.email,
		firstName: obj.first_name,
		lastName: obj.last_name ?? '',
		formCreationAccess: obj.form_creation_access,
		image: obj.image ?? '',
		pages: obj.pages?.map(getStructuredUserDetailsPage) ?? [],
		hasSubmissions: obj.has_submissions,
		proEnabled: obj.pro_enabled ?? false,
		bannerShown: obj.banner_shown ?? false,
		showOnboarding: obj.show_onboarding,
	};

	return structuredObj;
}

export function getFullName(obj: ISUserDetails | null) {
	return `${obj?.firstName ?? ''} ${obj?.lastName ?? ''}`;
}
